import React, { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { withAuthorizationVerifier } from "../../components/authorization-verifier";
import { useProperty } from "../../components/property-provider";
import actions from "../../lib/actions";
import { useConfig } from "../../lib/config";
import { useApiClient, useHttpClient } from "../../lib/http";
import { regenPropertyCache } from "../common/api";
import CrudForm from "../shared/crud/form";
import { EngineGuestDataEntity } from "./domain/engineGuestData.entity";
import { buildFormConfiguration } from "./domain/engineGuestData.formConfiguration";
import schema from "./domain/engineGuestData.schema.json";
import { getEntity, updateEntity } from "./infrastructure/engineGuestData.api";
import { messages } from "./messages";

export const FormContainer = styled("div")`
  .form-group.field.field-boolean {
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
  select {
    width: 280px;
  }
  input[type="text"] {
    width: 280px;
  }
`;

function EngineGuestDataForm({ propertyTicker }: { propertyTicker: string }) {
  const intl = useIntl();
  const propertyInfo = useProperty();
  const configuration = useConfig();
  const middlewareClient = useHttpClient(configuration.middlewareEndpoint);
  const apiClient = useApiClient();

  const handleGetOne = useCallback(async () => {
    return await getEntity(middlewareClient, propertyInfo.ticker);
  }, [middlewareClient, propertyInfo.ticker]);

  const handleUpdate: (entity: EngineGuestDataEntity) => Promise<void> = useCallback(
    async entity => {
      await updateEntity(propertyInfo.ticker, entity, middlewareClient);
      await regenPropertyCache(apiClient, propertyInfo.ticker);
      alert(intl.formatMessage(messages.saveSuccess));
      return;
    },
    [apiClient, intl, middlewareClient, propertyInfo.ticker]
  );
  const formConfiguration = useMemo(() => buildFormConfiguration(), []);

  return (
    <CrudForm<EngineGuestDataEntity>
      id={"engineGuestDataEntity"}
      schema={schema}
      formConfiguration={formConfiguration}
      messages={messages}
      onGet={handleGetOne}
      onUpdate={handleUpdate}
      canUpdate={actions.ModifyBehaviorSettings}
      enumsOptional
      container={FormContainer}
    />
  );
}

export default withAuthorizationVerifier(EngineGuestDataForm);
